import { render, staticRenderFns } from "./LegalInformation.vue?vue&type=template&id=d18249da"
import script from "./LegalInformation.vue?vue&type=script&lang=js"
export * from "./LegalInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports